import Vue from 'vue'
import Router from 'vue-router'
import Layout from './components/Layout'
import Home from './views/Home'
import Services from './views/Services'
import Tarifs from './views/Tarifs'
import Presentation from './views/Presentation'
import MentionsLegales from './views/MentionsLegales'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      component: Layout,
      children: [
        { path: '/', name: 'home', component: Home },
        { path: 'prestations', name: 'services', component: Services },
        { path: 'tarifs', name: 'tarifs', component: Tarifs },
        { path: 'presentation', name: 'presentation', component: Presentation },
        { path: 'mentionslegales', name: 'mentionslegales', component: MentionsLegales }
      ]
    }
  ]
})
